import { Navigate, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/')({
  component: () => <Navigate from="/workspaces/$workspaceId/bots/$botId/webchat/" to="./v2/identity" />,
})
